<ps-header [hideShadow]="true" class="header-links-wrapper ps-padding-y-tiny">
  <ps-header-prefix>
    <span>{{ 'APP.BUSINESS' | translate }}</span>
  </ps-header-prefix>
  <ps-header-suffix>
    <div>
      <div class="right-navigation" *ngIf="!isCombinedApplication">
        <a class="ps-margin-right-small" href="{{ 'APP.EXCLUSIVE_OFFERS_LINK' | translate }}" target="_blank">
          <span>{{ 'APP.EXCLUSIVE_OFFERS' | translate }}</span>
        </a>

        <a class="ps-margin-right-small" href="{{ 'APP.HELP_LINK' | translate }}" target="_blank">
          <ps-icon class="ps-margin-right-small">questionmark</ps-icon>
          <span>{{ 'APP.HELP' | translate }}</span>
        </a>

        <a class="language-wrapper ps-margin-right-small">
          <ps-icon class="ps-margin-right-small">planet</ps-icon>
          <span>{{ 'APP.PAGE_DEFAULT_LANGUAGE' | translate }}</span>
        </a>
      </div>
      <div class="right-navigation" *ngIf="isCombinedApplication">
        <a class="ps-margin-right-small" href="{{ 'APP.EXCLUSIVE_OFFERS_SKRILL_LINK' | translate }}" target="_blank">
          <span>{{ 'APP.EXCLUSIVE_OFFERS_SKRILL' | translate }}</span>
        </a>

        <a class="ps-margin-right-small" href="{{ 'APP.EXCLUSIVE_OFFERS_NETELLER_LINK' | translate }}" target="_blank">
          <span>{{ 'APP.EXCLUSIVE_OFFERS_NETELLER' | translate }}</span>
        </a>

        <a class="ps-margin-right-small" href="{{ 'APP.HELP_SKRILL_LINK' | translate }}" target="_blank">
          <ps-icon class="ps-margin-right-small">questionmark</ps-icon>
          <span>{{ 'APP.HELP_SKRILL' | translate }}</span>
        </a>

        <a class="ps-margin-right-small" href="{{ 'APP.HELP_NETELLER_LINK' | translate }}" target="_blank">
          <ps-icon class="ps-margin-right-small">questionmark</ps-icon>
          <span>{{ 'APP.HELP_NETELLER' | translate }}</span>
        </a>

        <a class="language-wrapper ps-margin-right-small">
          <ps-icon class="ps-margin-right-small">planet</ps-icon>
          <span>{{ 'APP.PAGE_DEFAULT_LANGUAGE' | translate }}</span>
        </a>
      </div>
    </div>
  </ps-header-suffix>
</ps-header>
